module.exports = __webpack_public_path__ + "static/media/APE.f222c8be.png";